import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * Should it be active or not
   */ active: PropTypes.bool,
    /**
   * Should it be disabled or not
   */ disabled: PropTypes.bool,
    /**
   * @deprecated use `accessibleText` prop instead
   * Provide the text that should be used for screen readers.
   */ visuallyHiddenText: deprecatedProp(PropTypes.string, DEPRECATED_PROP_MESSAGES.accessibleText),
    /**
   * Provide the text that should be used for screen readers.
   */ accessibleText: PropTypes.string
};
/**
 * @subcomponent Pagination
 */ const PaginationStep = createComponent({
    displayName: 'PaginationStep',
    root: 'a',
    propTypes,
    propConfig: {
        processProps (props) {
            const { disabled, active, visuallyHiddenText, accessibleText = visuallyHiddenText, as, component } = props;
            const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenText;
            return _object_spread_props(_object_spread({
                'aria-label': accessibleNode !== null && accessibleNode !== void 0 ? accessibleNode : undefined
            }, props), {
                as: disabled && 'span' || as || component || 'a',
                'aria-current': !!active
            });
        },
        classNames (props) {
            const classNameSet = new Set([
                'swan-pagination-step'
            ]);
            if (props.disabled) classNameSet.add('swan-pagination-step-disabled');
            if (props.active) classNameSet.add('swan-pagination-step-active');
            return classNameSet;
        }
    }
});

export { PaginationStep };
